const ISO_DATE_TIME_WITHOUT_ZONE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;

const normalizeEpoch = (value: number) => Math.abs(value) < 1_000_000_000_000 ? value * 1000 : value;

export const parseUtcDateTime = (value: string | number | null | undefined): Date | null => {
  if (value === null || value === undefined || value === "") return null;

  let normalizedValue: string | number = value;
  if (typeof value === "number") {
    normalizedValue = normalizeEpoch(value);
  } else {
    const trimmedValue = value.trim();
    if (/^-?\d+(?:\.\d+)?$/.test(trimmedValue)) {
      normalizedValue = normalizeEpoch(Number(trimmedValue));
    } else if (ISO_DATE_TIME_WITHOUT_ZONE.test(trimmedValue)) {
      // MongoDB BSON Date values are UTC. Legacy API responses omitted the
      // timezone suffix, so make their UTC meaning explicit before parsing.
      normalizedValue = `${trimmedValue}Z`;
    } else {
      normalizedValue = trimmedValue;
    }
  }

  const date = typeof normalizedValue === "number"
    ? new Date(normalizedValue)
    : new Date(normalizedValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatUserDateTime = (
  value: string | number | null | undefined,
  locale: string
) => {
  const date = parseUtcDateTime(value);
  if (!date) return value ? String(value) : "-";

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(locale || "en", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  }).format(date);
};
